import * as React from "react";

export const GeoStatusDumpCleanerTab = () => (
    <div style={{ height: "calc(100vh - 220px)", minHeight: "640px" }}>
        <iframe
            title="GeoStatus Dump Cleaner"
            src="/GeoStatusDumpCleaner.html?v=20260608"
            style={{ width: "100%", height: "100%", border: 0, background: "#1e2127" }}
        />
    </div>
);
